import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-348edf32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "OFFERS TO BE REVIEWED")
], -1))
const _hoisted_3 = { class: "btns-wrapper" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "items-container" }
const _hoisted_8 = {
  key: 0,
  class: "empty-state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoader = _resolveComponent("SpinnerLoader")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_OfferItem = _resolveComponent("OfferItem")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_MainLayout = _resolveComponent("MainLayout")!

  return (_openBlock(), _createBlock(_component_MainLayout, null, {
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_SpinnerLoader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_v_divider),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                type: "button",
                disabled: _ctx.status === 'pending',
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleChangeStatusView('pending')))
              }, [
                _createVNode(_component_v_icon, {
                  icon: "mdi-refresh",
                  style: {"color":"#fff"}
                }),
                _createTextVNode(" View Pending ")
              ], 8, _hoisted_4),
              _createElementVNode("button", {
                type: "button",
                disabled: _ctx.status === 'accepted',
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleChangeStatusView('accepted')))
              }, [
                _createVNode(_component_v_icon, { icon: "mdi-check" }),
                _createTextVNode(" View Approved ")
              ], 8, _hoisted_5),
              _createElementVNode("button", {
                type: "button",
                disabled: _ctx.status === 'declined',
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleChangeStatusView('declined')))
              }, [
                _createVNode(_component_v_icon, { icon: "mdi-close" }),
                _createTextVNode(" View Declined ")
              ], 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Offers.offers, (offer) => {
                return (_openBlock(), _createBlock(_component_OfferItem, {
                  key: `offer-item-${offer.id}`,
                  offer: offer,
                  disabled: _ctx.isUpdating,
                  onApprove: _cache[3] || (_cache[3] = (id) => _ctx.handleChangeOfferStatus(id, 'accepted')),
                  onDecline: _cache[4] || (_cache[4] = (id) => _ctx.handleChangeOfferStatus(id, 'declined')),
                  onReset: _cache[5] || (_cache[5] = (id) => _ctx.handleChangeOfferStatus(id, 'pending'))
                }, null, 8, ["offer", "disabled"]))
              }), 128)),
              (!_ctx.Offers.offers.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.emptyOffersMessage), 1))
                : _createCommentVNode("", true),
              (_ctx.total > _ctx.limit)
                ? (_openBlock(), _createBlock(_component_PaginationComponent, {
                    key: 1,
                    pageSize: _ctx.limit,
                    data: _ctx.total,
                    "current-page": _ctx.currentPage,
                    onPageChanged: _ctx.updatePagination
                  }, null, 8, ["pageSize", "data", "current-page", "onPageChanged"]))
                : _createCommentVNode("", true)
            ])
          ]))
    ]),
    _: 1
  }))
}